import { useParams, Link } from "react-router-dom";
import { Droplets, Mountain, Thermometer, Hammer, Check, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site";

const ICONS = { Droplets, Mountain, Thermometer, Hammer };

export default function Services() {
  const { slug } = useParams();
  const active = slug ? SERVICES.find((s) => s.slug === slug) : null;
  return (
    <div data-testid="services-page">
      <section className="px-6 md:px-12 pt-28 pb-12">
        <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#d4af37]">— Hizmetlerimiz</p>
        <h1 className="mt-3 font-display font-extrabold tracking-tighter text-5xl md:text-7xl lg:text-[8rem] leading-[0.85] max-w-5xl">
          Premium yalıtım <span className="text-[#d4af37]">disiplinleri.</span>
        </h1>
      </section>

      {!active ? (
        <section className="px-6 md:px-12 pb-24 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {SERVICES.map((s, i) => {
            const Ic = ICONS[s.icon];
            return (
              <Link
                key={s.slug}
                to={`/hizmetlerimiz/${s.slug}`}
                data-testid={`services-grid-${s.slug}`}
                className="group relative aspect-[4/3] overflow-hidden bg-[#0a0a0a] ring-1 ring-white/5 hover:ring-[#d4af37]/60 transition"
              >
                <div className="absolute inset-0 bg-cover bg-center scale-105 group-hover:scale-110 transition duration-700" style={{ backgroundImage: `url(${s.image})` }} />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/60 to-transparent" />
                <div className="relative h-full p-7 flex flex-col justify-between">
                  <div className="flex items-start justify-between">
                    <Ic className="h-9 w-9 text-[#d4af37]" />
                    <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/45">0{i + 1}</span>
                  </div>
                  <div>
                    <div className="font-display text-3xl md:text-5xl tracking-tight">{s.title}</div>
                    <p className="text-white/65 mt-2 text-sm max-w-md">{s.short}</p>
                    <div className="mt-4 inline-flex items-center gap-2 text-[#d4af37] font-display text-xs uppercase tracking-[0.25em]">
                      Detay <ArrowUpRight className="h-3.5 w-3.5" />
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </section>
      ) : (
        <section className="px-6 md:px-12 pb-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img src={active.image} alt={active.title} className="absolute inset-0 w-full h-full object-cover" loading="eager" />
            </div>
          </div>
          <div className="lg:col-span-5">
            <h2 className="font-display font-extrabold tracking-tighter text-5xl text-[#d4af37]">{active.title}</h2>
            <p className="mt-6 text-white/70 leading-relaxed text-lg">{active.long}</p>
            <ul className="mt-8 space-y-3">
              {active.bullets.map((b) => (
                <li key={b} className="flex items-center gap-3 text-white/80">
                  <Check className="h-4 w-4 text-[#d4af37]" /> {b}
                </li>
              ))}
            </ul>
            <Link
              to="/iletisim"
              data-testid={`service-cta-${active.slug}`}
              className="mt-10 inline-flex items-center gap-3 bg-[#d4af37] text-[#121212] hover:bg-white px-7 py-4 font-display uppercase tracking-[0.18em] text-sm transition"
            >
              Bu Hizmet İçin Teklif Al →
            </Link>
            <div className="mt-10 pt-6 border-t border-white/5">
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/45 mb-4">Diğer Hizmetler</p>
              <div className="flex flex-wrap gap-2">
                {SERVICES.filter((s) => s.slug !== active.slug).map((s) => (
                  <Link key={s.slug} to={`/hizmetlerimiz/${s.slug}`} className="text-xs px-3 py-2 border border-white/10 hover:border-[#d4af37] hover:text-[#d4af37] transition">
                    {s.title}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
